<template>
  <div class="academy-rules">
    <section class="section-top">

      <h1 class="title">아카데미 회칙</h1>

      <p>
        본 회칙은 전남드래곤즈 유소년 회원 프로그램 리틀드래곤즈의 운영 기준을 정함을 목적으로 하며, 회원 가입 시 본 회칙 및 관련 안내 사항에 모두 동의한 것으로 본다.
      </p>

      <h6>제1조 (회원 자격 및 기간)</h6>
      <div class="desc">리틀드래곤즈 회원은 구단이 정한 절차에 따라 가입을 완료한 학생으로 한다. 보호자 동의 없이 가입할 수 없으며, 허위 정보 기재 시 회원 자격은 취소될 수 있다.</div>

      <h6>제2조 (회원 모집 및 선발)</h6>
      <div class="desc">
        <p class="list-num">
          <span>1.</span>회원 모집은 선착순으로 진행되며, 정원 마감 시 자동 종료된다.
        </p>
        <p class="list-num">
          <span>2.</span>중도 해지 및 결원 발생 시 구단은 필요에 따라 추가 모집을 진행할 수 있다.
        </p>
      </div>

      <h6>제3조 (유니폼 제작 및 변경 불가 안내)</h6>
      <div class="desc">
        <p class="list-num">
          <span>1.</span>유니폼은 회원 가입 시 신청한 정보를 바탕으로 개별 제작되므로, 제작 착수 이후에는 단순 변심에 의한 사이즈 및 마킹 정보 변경이 불가하다.
          (단, 수령한 제품이 주문 내용과 다르거나 제품 자체에 하자가 있는 경우, 구단은 즉시 교환 또는 재제작의 책임을 진다.)
        </p>
        <p class="list-num">
          <span>2.</span>회원의 관리 소홀로 인한 분실 및 훼손에 대해서는 구단이 책임지지 않는다.
        </p>
      </div>

      <h6>제4조 (시즌권 규정)</h6>
      <div class="desc">
        <p class="list-num">
          <span>1.</span>제공되는 시즌권은 회원 본인만 사용 가능하다.
        </p>
        <p class="list-num">
          <span>2.</span>시즌권의 보관 및 관리 책임은 전적으로 회원 및 보호자에게 있으며, 분실, 도난, 훼손 시 재발급되지 않는다.
        </p>
      </div>

      <h6>제5조 (환불 규정)</h6>
      <div class="desc">
        <p class="list-num">
          <span>1.</span>첫 수업 전 탈퇴 시에는 전액 환불을 원칙으로 한다. 단 첫 수업 진행 후에는 가입 취소 및 환불이 불가하다.
        </p>
        <p class="list-num">
          <span>2.</span>천재지변, 리그 운영 중단 등 불가항력적인 사유로 프로그램 운영이 중단될 경우, 환불 여부 및 범위는 구단이 별도로 정하는 기준에 따른다.
        </p>
        <p class="list-num">
          <span>3.</span>수업 결석, 개인 사정, 단순 변심 등을 사유로 한 회비 감액 또는 환불은 불가하다.
        </p>
      </div>

      <h6>제6조 (수업 운영 규정)</h6>
      <div class="desc">
        <p class="list-num">
          <span>1.</span>국가지정 공휴일 및 임시 공휴일에는 수업을 진행하지 않는다.
        </p>
        <p class="list-num">
          <span>2.</span>기상 악화, 천재지변, 시설 사정 등으로 수업 진행이 불가할 경우 해당 수업은 휴강될 수 있다.
        </p>
        <p class="list-num">
          <span>3.</span>제3항의 경우, 보강 수업 실시 여부 및 방식은 지도자 및 구단의 판단에 따라 결정된다.
        </p>
        <p class="list-num">
          <span>4.</span>보호자는 회원의 안전을 위하여 개인 상해보험 가입을 사전에 권장받으며, 미가입으로 인한 불이익에 대해 구단은 책임을 지지 않는다.
        </p>
      </div>

      <h6>제7조 (회비 규정)</h6>
      <div class="desc">
        <p class="list-num">
          <span>1.</span>리틀드래곤즈 일반 회원의 연간 회비는 350,000원으로 한다.
        </p>
        <p class="list-num">
          <span>2.</span>리틀드래곤즈 팀 회원의 입단비는 50,000원, 월 회비는 100,000원으로 하며, 월 4회 수업을 기준으로 한다.
        </p>
        <p class="list-num">
          <span>3.</span>리틀드래곤즈 팀 회원의 경우, 기상 악화 등으로 수업이 진행되지 못한 경우 익월 회비에서 차감하거나 별도 보강을 실시할 수 있다.
        </p>
      </div>

      <h6>제8조 (회칙의 변경 및 해석)</h6>
      <div class="desc">
        <p class="list-num">
          <span>1.</span>본 회칙은 구단의 운영 정책에 따라 변경될 수 있다.
        </p>
        <p class="list-num">
          <span>2.</span>본 회칙에 명시되지 않은 사항은 관계 법령 및 구단 내부 운영 방침에 따른다.
        </p>
      </div>

    </section>
  </div>
</template>

<script>

export default {
  name: 'AcademyRules',
  props: ['routeName'],
  data() {
    return {

    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
</style>